import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { firstValueFrom } from 'rxjs';
import { DistributionChannelRequest, DistributionChannelsService } from '@src/app/shared/backend/clients';
import { BaseViewComponent } from '@src/app/shared/components/base-list/base-view.component';

@Component({
    selector: 'app-add-distribution-channel',
    templateUrl: './add-distribution-channel.component.html',
    styleUrl: './add-distribution-channel.component.scss',
    host: {
        class: 'app-add-distribution-channel'
    },
    standalone: false
})
export class AddDistributionChannelComponent extends BaseViewComponent implements OnInit {

  totalRecords: number = 0;
  rowsPerPageOption: number = 5;
  usersList: string[] = [];

  public distributionChannelForm: FormGroup = this.fb.group({
    name: ['', [Validators.required, Validators.maxLength(50)]],
    code: ['', [Validators.required, Validators.maxLength(50)]],
    hasParentDistributionChannel: ['false']
  });

  constructor(
    private router: Router,
    private distributionChannelsService: DistributionChannelsService,
    private fb: FormBuilder
  ) { super(); }

  ngOnInit() { }

  async submitForm() {
    if (this.distributionChannelForm.valid) {
      const payload: DistributionChannelRequest = {
        name: this.distributionChannelForm.controls['name'].value,
        code: this.distributionChannelForm.controls['code'].value
      };

      await firstValueFrom(this.distributionChannelsService.apiDistributionChannelsCreatePost(payload));

      this.distributionChannelForm.controls['code'].setValue(null);
      this.distributionChannelForm.controls['name'].setValue(null);

      this.router.navigate(['/distribution-channels']);
    }
  }
}
